module.exports = __webpack_public_path__ + "img/product-program-switch-dzjqr.aa5486ad.png";